<template>
  <div class="gis-export-geom-container">
    <SelectButton
      v-model="projection"
      :options="optionsProjections"
      aria-labelledby="basic"
      option-label="label"
      option-value="value"
      class="full-select-buttons"
    />
  </div>

  <hr class="m-0 mt-2 mb-1" />
  <div class="mt-1 gis-export-geom-download">
    <Button @click="exportGeometry" :label="$t('Export')" severity="primary" icon="fa fa-download" size="small" />
  </div>
  <Loader :is-loading="isLoading" />
</template>

<script lang="ts">
import store from '../../js/store';
import { saveAs } from 'file-saver';
import Loader from '@/components/common/Loader.vue';
import { v4 as uuid } from 'uuid';
import { mapGetters } from 'vuex';
import { config } from '@/config/config';
import { paramsToUrlQuery } from '../../js/utils';
import _ from 'lodash';

export default {
  name: 'ExportGeometry',
  inject: ['dialogRef'],
  components: { Loader },
  computed: {
    ...mapGetters({
      token: 'GET_TOKEN',
      common: 'GET_COMMON_DATA',
    }),
  },
  data() {
    return {
      projection: 3844,
      isLoading: false,
      optionsProjections: [
        { label: this.$t('Wgs 84'), value: null, code: null, projectionId: 7970 },
        {
          label: this.$t('Stereo 70'),
          value: 3844,
          code: 3844,
          projectionId: 6545,
        },
      ],
    };
  },
  methods: {
    exportGeometry() {
      if (this.dialogRef?.data) {
        this.isLoading = true;
        const exportDispatchObject = this.dialogRef?.data?.exportDispatchObject;
        let mapController = this.dialogRef?.data?.mapController;
        exportDispatchObject.query.projection = this.projection;
        if (this.common?.configs?.useWebSocket) {
          this.isLoading = false;

          const worker = new Worker(new URL('../../download-worker.js', import.meta.url), {
            type: 'module',
          });

          const process_uid = uuid();
          const safeParams = _.cloneDeep(exportDispatchObject?.data);
          worker.postMessage({
            type: 'download',
            data: {
              url: config.SYNC_API_URL,
              token: mapController?.configuration?.accessToken ?? this.token,
              fingerprint: localStorage.getItem('user-fingerprint'),
              query: {
                ...(exportDispatchObject?.query ?? {}),
                worker: true,
                worker_uid: process_uid,
                type: 'download',
              },
              methodType: 'POST',
              data: {
                ...safeParams,
                type: 'download',
              },
            },
          });

          this.$toast.add({
            severity: 'success',
            summary: this.$t('Notification'),
            detail: this.$t('Export in background!'),
            life: 5000,
          });

          worker.onmessage = (message) => {
            if (message.data.status == 500) {
              this.$toast.add({
                severity: 'error',
                summary: 'Error',
                detail: 'Eroare',
                life: 5000,
              });
            }
          };

          this.dialogRef.close();
        } else {
          store.dispatch('exportGeometries', exportDispatchObject).then((response) => {
            this.isLoading = false;
            if (response && response.file) {
              const bytes = new Uint8Array(response.file.data);
              const blob = new Blob([bytes]);
              saveAs(blob, response.fileName + (response.extension ? response.extension : '.zip'));

              this.dialogRef.close();
            }
          });
        }
      }
    },
  },
};
</script>

<style>
.gis-export-geom-container {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}

.gis-export-geom-download {
  float: right;
}

.full-select-buttons {
  display: flex;
  width: 100%;
  & > div {
    flex: 1;
  }
}
</style>
